import classNames from "classnames";
import { intersection } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

import { getTranslationKey } from "../../../../../helpers/custom_pptx_template";
import { CustomType } from "../../../../types";
import {
  EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL,
  EY_CERTIFICATES_FIELD_NAMES_OTHER
} from "../../../constants";
import css from "./certificates.module.scss";
import { CustomField } from "./custom_field";

type CustomFieldProps = {
  customTypes: CustomType[];
  names: string[];
  templateKey: string;
};

export const Certificates = ({ customTypes, names, templateKey }: CustomFieldProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "export" });

  const educationalNames = intersection(names, EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL);
  const otherNames = intersection(names, EY_CERTIFICATES_FIELD_NAMES_OTHER);
  const translationKey = getTranslationKey(templateKey);
  const educationalValues = customTypes.find(
    ({ text, type }) => text && educationalNames.includes(type.name)
  );
  const otherValues = customTypes.find(({ text, type }) => text && otherNames.includes(type.name));

  return (
    <div
      className={classNames(css.certificates, {
        [css.grid]: educationalValues && otherValues
      })}
    >
      {educationalValues && (
        <CustomField
          contentClassName={css.content}
          className={css.item}
          customTypes={customTypes}
          names={educationalNames}
          title={t(`${translationKey}.certificatesEducational`)}
        />
      )}
      {otherValues && (
        <CustomField
          contentClassName={css.content}
          className={css.item}
          customTypes={customTypes}
          names={otherNames}
          title={t(`${translationKey}.certificates`)}
        />
      )}
    </div>
  );
};
